/* ==========================================================================
   Conversion product page — gallery thumbnails and the routine picker.

   - Gallery: thumbnails switch the main image; the benefit overlay stays on
     the first image only.
   - Routine picker: each option is a real product (this one, or a bundle that
     contains it). Picking one swaps the variant the buy form adds and the
     price on its button. Nothing is hidden or broken without JS: the form
     simply adds this product, as the first option says.
   - Review carousel: a scroll-snap row; arrows step a card at a time, the
     dots follow the scroll, long reviews open with "Read more". Without JS
     it is still a row you can swipe.
   ========================================================================== */
(() => {
  if (window.__sellInit) return;
  window.__sellInit = true;

  function setupGallery(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const show = (i) => {
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.slide === String(i)));
      thumbs.forEach((t) => {
        const on = t.dataset.thumb === String(i);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      root.classList.toggle('is-first', String(i) === '0');
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.thumb)));
    show(0);
  }

  function setupOffers(fieldset) {
    if (fieldset.dataset.ready) return;
    fieldset.dataset.ready = '1';
    const hero = fieldset.closest('.sell-buy');
    const wrap = hero?.querySelector('[data-sell-form]');
    if (!wrap) return;
    const template = wrap.dataset.label || 'Add to Cart · [price]';

    const apply = (input) => {
      fieldset.querySelectorAll('.sell-offer').forEach((l) => l.classList.toggle('is-selected', l.contains(input)));
      const idField = wrap.querySelector('input[name="id"]');
      if (idField) idField.value = input.value;
      const component = wrap.querySelector('product-form-component');
      if (component && input.dataset.productId) component.dataset.productId = input.dataset.productId;
      const label = wrap.querySelector('.add-to-cart-text__content > span > span');
      if (label) label.textContent = template.replace('[price]', input.dataset.price || '');
    };

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => apply(input));
    });
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) apply(checked);
  }

  function setupReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    if (!track) return;
    const cards = [...track.children];
    const arrows = [...root.querySelectorAll('.sell-reviews__arrow')];
    const dotsWrap = root.querySelector('[data-dots]');

    // "Read more" only where the text is actually cut off
    cards.forEach((card) => {
      const text = card.querySelector('[data-review-text]');
      const more = card.querySelector('[data-review-more]');
      if (!text || !more) return;
      if (text.scrollHeight > text.clientHeight + 2) more.hidden = false;
      more.addEventListener('click', () => {
        const open = card.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Read more';
      });
    });

    const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth);
    const maxScroll = () => track.scrollWidth - track.clientWidth;
    const pages = () => Math.max(1, Math.round(maxScroll() / step()) + 1);

    let dots = [];
    const drawDots = () => {
      if (!dotsWrap) return;
      const n = pages();
      if (dots.length === n) return;
      dotsWrap.replaceChildren(...Array.from({ length: n }, () => document.createElement('span')));
      dots = [...dotsWrap.children];
      dotsWrap.hidden = n < 2;
    };

    const sync = () => {
      const at = track.scrollLeft;
      const index = Math.round(at / step());
      dots.forEach((d, i) => d.classList.toggle('is-active', i === Math.min(index, dots.length - 1)));
      if (arrows[0]) arrows[0].disabled = at <= 2;
      if (arrows[1]) arrows[1].disabled = at >= maxScroll() - 2;
    };

    const go = (dir) => {
      const atEnd = track.scrollLeft >= maxScroll() - 2;
      const left = dir > 0 && atEnd ? 0 : track.scrollLeft + dir * step();
      track.scrollTo({ left, behavior: 'smooth' });
    };

    arrows.forEach((a) => a.addEventListener('click', () => go(Number(a.dataset.dir))));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    new ResizeObserver(() => { drawDots(); sync(); }).observe(track);
    drawDots();
    sync();

    // optional autoplay: pauses while hovered, focused or off screen, never with reduced motion
    const delay = Number(root.dataset.autoplay);
    if (!delay || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let visible = false;
    let held = false;
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(root);
    ['pointerenter', 'focusin'].forEach((t) => root.addEventListener(t, () => { held = true; }));
    ['pointerleave', 'focusout'].forEach((t) => root.addEventListener(t, () => { held = false; }));
    setInterval(() => { if (visible && !held && !document.hidden) go(1); }, delay);
  }

  function scan(scope) {
    scope.querySelectorAll('[data-sell-gallery]').forEach(setupGallery);
    scope.querySelectorAll('[data-sell-offers]').forEach(setupOffers);
    scope.querySelectorAll('[data-sell-reviews]').forEach(setupReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
